const env = window._env_ || {};

export const BACKEND_BASE_URL =
  env.REACT_APP_BACKEND_BASEURL &&
  env.REACT_APP_BACKEND_BASEURL !== "__REACT_APP_BACKEND_BASEURL__"
    ? env.REACT_APP_BACKEND_BASEURL
    : process.env.REACT_APP_BACKEND_BASEURL;

export const REACT_APP_CAPTCHA_KEY =
  env.REACT_APP_CAPTCHA_KEY &&
  env.REACT_APP_CAPTCHA_KEY !== "__REACT_APP_CAPTCHA_KEY__"
    ? env.REACT_APP_CAPTCHA_KEY
    : process.env.REACT_APP_CAPTCHA_KEY;

export const REACT_APP_APPINSIGHTS_CONNECTION_STRING =
  env.REACT_APP_APPINSIGHTS_CONNECTION_STRING &&
  env.REACT_APP_APPINSIGHTS_CONNECTION_STRING !== "__REACT_APP_APPINSIGHTS_CONNECTION_STRING__"
    ? env.REACT_APP_APPINSIGHTS_CONNECTION_STRING
    : process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;